module.exports = {"TXTCLI_Show_More_Options":{"id":"TXTCLI_Show_More_Options","defaultMessage":"Pokaži več možnosti"}}